<div>
    <hr />
    @if (content.publicationHistory) {
    <p class="ml-3"><strong><em>{{ content.publicationHistory.length > 0 ? 'Content changes':'No content changes'}}</em></strong></p>
    }
    <div class="content-wrapper m-3">
        @for (item of content.publicationHistory; track item) {
        <div class="pb-3">
            <p class="mb-1 pt-1 pb-1">
                <span class="d-inline item-heading">{{getHierarchyDisplayText(item.hierarchy)}}</span>
            </p>
            <div class="pl-3">
                <div class="user-content" [innerHTML]="item.text"></div>
                <small>
                    <div><em> Modified date: {{item.datePublished | date:'d-MM-yyyy hh:mm a'}} </em></div>
                    @if (item.metadata && item.metadata.length > 0) {
                    <strong>Source:</strong>
                    @for (metadataItem of item.metadata; track metadataItem; let i = $index) {
                    <span>
                        @if (hasUrl(metadataItem)) {
                        <a [href]="getUrl(metadataItem)" [title]="getUrl(metadataItem)" target="_blank">{{metadataItem.name}}</a>
                        }
                        @if (!hasUrl(metadataItem)) {
                        {{metadataItem.name}}
                        }
                    </span>
                    - {{metadataItem.value}}.
                    }
                    }
                </small>
            </div>
        </div>
        }
    </div>

</div>